// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionTitle_sectionTitle__Cx2+P","sectionTitle2":"SectionTitle_sectionTitle2__BEXfM"};